var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportAndHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 20V21C15.38 21 16.27 20.574 16.95 20H14.26Z",
    fill: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.479 15.002V16.002C9.479 17.252 10.435 17.502 10.435 17.502C10.435 17.502 11.391 20.503 14.261 20.503",
    stroke: "#76BC21",
    strokeWidth: 0.833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.521 15.502H18.086C18.086 12.381 16.652 11.001 16.652 11.001C15.217 14.501 10.435 12.001 10.435 15.501H9V13.501C9 10.001 11.87 8 14.26 8C16.174 8 16.652 9 16.652 9C18.565 9 19.522 11.5 19.522 13.501V15.501L19.521 15.502Z",
    fill: "#76BC21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.502H14.021C13.626 17.502 13.304 17.838 13.304 18.252C13.304 18.666 13.626 19.002 14.021 19.002H14.5C14.896 19.002 15.217 18.666 15.217 18.252C15.217 17.838 14.896 17.502 14.5 17.502Z",
    fill: "#76BC21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.738 18.503H17.129C18.186 18.503 19.042 17.607 19.042 16.503V15.002",
    stroke: "#76BC21",
    strokeWidth: 0.833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0429 16.998H18.0869V14.498H19.0429C19.5719 14.498 19.9999 14.946 19.9999 15.498V15.998C19.9999 16.551 19.5719 16.998 19.0429 16.998Z",
    fill: "#76BC21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportAndHelp);
export default __webpack_public_path__ + "static/media/supportAndHelp.38d6b5f374af8339cec29efbac8eb2b2.svg";
export { ForwardRef as ReactComponent };